import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useReopenOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) => updateOrder(data, OrderStatus.opened);

  return useApiMutation({
    url: `/orders/${orderId}/opened`,
    method: 'PATCH',
    errorTitle: 'Erro ao reabrir pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido reaberto!',
    onSuccess,
  });
};

export default useReopenOrder;
